import {useFieldArray, useFormContext} from "react-hook-form";

import {EmailListInput} from "@/components/form/EmailListInput.tsx";
import {InputField, InputFieldProps} from "@/components/form/fields/InputField/InputField.tsx";
import {ListInputItemsList} from "@/components/form/ListInputItemsList.tsx";

export const EmailListField = ({name, ...rest}: InputFieldProps) => {
  const {getValues, control} = useFormContext();
  const {remove} = useFieldArray({control, name});

  return (
    <>
      <InputField name={name} input={<EmailListInput name={name} />} {...rest} />
      <ListInputItemsList items={getValues(name) || []} remove={remove} />
    </>
  );
};
